import { tWithKeyAttr as t } from "../../i18nHelper";
import mainPageStyles from "../main/mainPage.module.css";
import styles from "./pendingReports.module.css";
import { getPrintDate } from "../../utils/utils";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../services/hooks";
import {
  pendingReportAppointmentsSelector,
  pendingReportInquiriesSelector,
  statusesSelector,
} from "../../services/selectors/user.selectors";
import {
  useGetPendingReportsQuery,
} from "../../services/api/user.api";
import Loader from "../../components/loader/loader";
import useMediaQuery from "../../hooks/useMediaQuery";
import { mobileWidth } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import {
  TPendingInquiry,
  TPendingReport,
} from "../../services/types/user.types";
import { getServerStatusText } from "../../utils/therapistDocuments";
import ListPagination from "../../components/listPagination/listPagination";
import { TLimits } from "../../types/types";
import i18n from "../../i18n";
import BackArrowButton from "../../components/backArrowButton/backArrowButton";

function PendingReportsPage() {
  const navigate = useNavigate();
  const { isLoading, isError } = useGetPendingReportsQuery();

  const pendingReportAppointments = useAppSelector(
    pendingReportAppointmentsSelector
  );
  const pendingReportInquiries = useAppSelector(pendingReportInquiriesSelector);
  const serverStatuses = useAppSelector(statusesSelector);

  //limit inquiries to 6
  const limitNumber = 6;

  const [pendingInquiriesLimits, setPendingInquiriesLimits] = useState<TLimits>(
    { start: 1, end: 1 }
  );
  const [pendingAppointmentsLimits, setPendingAppointmentsLimits] =
    useState<TLimits>({ start: 1, end: 1 });

  const mobile = useMediaQuery(mobileWidth);

  useEffect(() => {
    if (pendingReportInquiries.length > 0) {
      setPendingInquiriesLimits((prev) => ({
        ...prev,
        end:
          limitNumber < pendingReportInquiries.length
            ? limitNumber
            : pendingReportInquiries.length,
      }));
    }
  }, [pendingReportInquiries.length, setPendingInquiriesLimits]);
  useEffect(() => {
    if (pendingReportAppointments.length > 0) {
      setPendingAppointmentsLimits((prev) => ({
        ...prev,
        end:
          limitNumber < pendingReportAppointments.length
            ? limitNumber
            : pendingReportAppointments.length,
      }));
    }
  }, [pendingReportAppointments.length, setPendingInquiriesLimits]);

  const navigateToActionReport = (appointment: TPendingReport) => {
    navigate(`/users/report/`, {
      state: {
        TherapistDetails: {
          QuestionnaireCompaniesTypeId: 3,
          appointmentsId: appointment.appointment.id,
        },
        UserDetails: {
          FirstName: appointment.appointment.users?.firstName,
          LastName: appointment.appointment.users?.lastName,
          Phone: appointment.appointment.users?.phone,
          // Birth: treatmentPlan.user.Birth,
          UsersId: appointment.appointment.users?.id,
          Guid: appointment.appointment.users?.guid,
        },
      },
    });
  };
  const navigateToActionReportForInquiry = (document: TPendingInquiry) => {
      navigate(`/users/report/`, {
        state: {
          TherapistDetails: {
            TherapistQuestionnaireId: document.therapistQuestionnaireId,
            QuestionnaireCompaniesType: document.questionnaireCompaniesType,
            QuestionnaireCompaniesId: document.questionnaireCompaniesId,
            TherapistCycle: document?.cycle,
          },
          UserDetails: {
            FirstName: document.firstName,
            LastName: document.lastName,
            Phone: document.phone,
            Birth: document.birth,
            userDocument: document,
            UsersId: document.usersId,
            Guid: document.guid,
          },
        },
      });
  };

  return (
    <section className={`${mainPageStyles.section} ${styles.section}`}>
      <BackArrowButton
        text={t('PREVIOUS_SCREEN')}
        onClick={() => navigate(-1)}
        position={"left"}
      />

      <article className={`${mainPageStyles.home__section} ${styles.section}`}>
        <h4 className={mainPageStyles.home__sectionTitle}>
          {t("PENDING_REPORTS_INQUIRIES_HEADER")}
        </h4>
        <ul className={mainPageStyles.inquiries} dir={i18n.dir()}>
          <div className={mainPageStyles.tableContentContainer}>
            {pendingReportInquiries.length > 0 ? (
              <li
                className={`${mainPageStyles.inquiry} ${styles.li} ${mainPageStyles.inquiryHeader}`}
              >
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {t("PENDING_REPORTS_INQUIRY_NUMBER")}
                </p>
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {t("PENDING_REPORTS_DATE")}
                </p>
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {mobile
                    ? t("PENDING_REPORTS_NAME_MOBILE")
                    : t("PENDING_REPORTS_NAME_DESKTOP")}
                </p>
                {!mobile && (
                  <p className={`${mainPageStyles.inquiryCell}`}>
                    {t("PENDING_REPORTS_CYCLE")}
                  </p>
                )}
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {mobile
                    ? t("PENDING_REPORTS_SUBJECT_MOBILE")
                    : t("PENDING_REPORTS_SUBJECT_DESKTOP")}
                </p>
                {!mobile && (
                  <p className={`${mainPageStyles.inquiryCell}`}>
                    {t("PENDING_REPORTS_STATUS")}
                  </p>
                )}
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {t("PENDING_REPORTS_REPORT")}
                </p>
              </li>
            ) : isLoading ? (
              <div className={mainPageStyles.text}>
                <Loader />
              </div>
            ) : (
              <p className={mainPageStyles.text}>
                {isError
                  ? t("PENDING_REPORTS_INQUIRIES_ERROR")
                  : t("PENDING_REPORTS_INQUIRIES_EMPTY")}
              </p>
            )}
          </div>
          {pendingReportInquiries.map(
            (i, index) =>
              index >= pendingInquiriesLimits.start - 1 &&
              index < pendingInquiriesLimits.end && (
                <li
                  key={i.num}
                  className={`${mainPageStyles.inquiry} ${styles.li} ${index % 2 === 0 && mainPageStyles.inquiry_colored
                    }`}
                >
                  <p className={`${mainPageStyles.inquiryCell}`}>{i.num}</p>
                  <p className={`${mainPageStyles.inquiryCell}`}>
                    {`${getPrintDate(new Date(i.timestamp))}`}
                  </p>
                  <p className={`${mainPageStyles.inquiryCell}`}>
                    {i.userName || ""}
                  </p>
                  {!mobile && (
                    <p className={`${mainPageStyles.inquiryCell}`}>{i.cycle}</p>
                  )}
                  <p className={`${mainPageStyles.inquiryCell}`}>
                    {i.questionnaireCompaniesType}
                  </p>
                  {!mobile && (
                    <p className={`${mainPageStyles.inquiryCell}`}>
                      {getServerStatusText(3, serverStatuses)}
                    </p>
                  )}
                  <button
                    className={`${styles.inquiryCell} button button_white ${styles.btn}`}
                    onClick={() => {
                      navigateToActionReportForInquiry(i);
                    }}
                  >
                    {t("PENDING_REPORTS_ACTION_REPORT_BUTTON")}
                  </button>
                </li>
              )
          )}
        </ul>
      </article>
      {pendingReportInquiries?.length > 0 && (
        <ListPagination
          limits={pendingInquiriesLimits}
          total={pendingReportInquiries?.length || 0}
          setLimits={setPendingInquiriesLimits}
          step={limitNumber}
        />
      )}
      <article className={`${mainPageStyles.home__section} ${styles.section}`}>
        <h4 className={mainPageStyles.home__sectionTitle}>
          {t("PENDING_REPORTS_APPOINTMENTS_HEADER")}
        </h4>
        {pendingReportAppointments?.length > 0 ? (
          <ul className={mainPageStyles.inquiries} dir={i18n.dir()}>
            <li
              className={`${mainPageStyles.inquiry} ${styles.li} ${mainPageStyles.inquiryHeader}`}
            >
              <p className={`${mainPageStyles.inquiryCell}`}>
                {t("PENDING_REPORTS_APPOINTMENT_NUMBER")}
              </p>
              <p className={`${mainPageStyles.inquiryCell}`}>
                {t("PENDING_REPORTS_DATE")}
              </p>
              <p className={`${mainPageStyles.inquiryCell}`}>
                {t("PENDING_REPORTS_PATIENT_NAME")}
              </p>
              <p className={`${mainPageStyles.inquiryCell}`}>
                {t("PENDING_REPORTS_TREATMENT_PLAN_NUMBER")}
              </p>
              {!mobile && (
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {t("PENDING_REPORTS_APPOINTMENT_START_TIME")}
                </p>
              )}
              {!mobile && (
                <p className={`${mainPageStyles.inquiryCell}`}>
                  {t("PENDING_REPORTS_APPOINTMENT_END_TIME")}
                </p>
              )}
              <p className={`${mainPageStyles.inquiryCell}`}>
                {t("PENDING_REPORTS_ACTION_REPORT_BUTTON")}
              </p>
            </li>
            {pendingReportAppointments.map(
              (a, index) =>
                index >= pendingAppointmentsLimits.start - 1 &&
                index < pendingAppointmentsLimits.end && (
                  <li
                    key={a.appointment.id}
                    className={`${mainPageStyles.inquiry} ${styles.li} ${index % 2 === 0 && mainPageStyles.inquiry_colored
                      }`}
                  >
                    <p className={`${mainPageStyles.inquiryCell}`}>
                      {a.appointment.id}
                    </p>
                    <p className={`${mainPageStyles.inquiryCell}`}>
                      {`${getPrintDate(
                        new Date(a.appointment.appointmentDate)
                      )}`}
                    </p>
                    <p className={`${mainPageStyles.inquiryCell}`}>
                      {a.userName || ""}
                    </p>
                    <p className={`${mainPageStyles.inquiryCell}`}>
                      {a.appointment.appointmentsProgramsId || "-"}
                    </p>
                    {!mobile && (
                      <p className={`${mainPageStyles.inquiryCell}`}>
                        {a.appointment.startTime}
                      </p>
                    )}
                    {!mobile && (
                      <p className={`${mainPageStyles.inquiryCell}`}>
                        {a.appointment.endTime}
                      </p>
                    )}
                    <button
                      className={`${styles.inquiryCell} button button_white ${styles.btn}`}
                      onClick={() => {
                        navigateToActionReport(a);
                      }}
                    >
                      {t("PENDING_REPORTS_ACTION_REPORT_BUTTON")}
                    </button>
                  </li>
                )
            )}
          </ul>
        ) : isLoading ? (
          <div className={mainPageStyles.text}>
            <Loader />
          </div>
        ) : (
          <p className={mainPageStyles.text}>
            {isError
              ? t("PENDING_REPORTS_APPOINTMENTS_ERROR")
              : t("PENDING_REPORTS_APPOINTMENTS_EMPTY")}
          </p>
        )}
      </article>
      {pendingReportAppointments?.length > 0 && (
        <ListPagination
          limits={pendingAppointmentsLimits}
          total={pendingReportAppointments?.length || 0}
          setLimits={setPendingAppointmentsLimits}
          step={limitNumber}
        />
      )}
    </section>
  );
}

export default PendingReportsPage;
